export default __webpack_public_path__ + "static/media/positive.00f039d3.svg";